import type { ReactNode } from 'react';
import { CustomTooltip } from '@/app/components/shared/CustomTooltip';
import { Button } from '@/app/components/ui/button';

interface ActionButtonProps {
  tooltip: string;
  icon: ReactNode;
  disabled?: boolean;
  stopPropagation?: boolean;
  onClick: () => void;
}

export const ActionButton = ({ tooltip, icon, disabled, stopPropagation, onClick }: ActionButtonProps) => (
  <CustomTooltip content={tooltip} side="top" disableHoverableContent={true}>
    <Button
      variant="text"
      size="sm"
      disabled={disabled}
      className="h-auto rounded-8 p-2 text-system-white40 hover:bg-system-white08 hover:text-system-white disabled:opacity-40"
      onClick={(event) => {
        if (stopPropagation) event.stopPropagation();
        onClick();
      }}
    >
      {icon}
    </Button>
  </CustomTooltip>
);
